(function($, undefined) {
	'use strict';

	var init = function() {
		if ($('.videos-init-js').length > 0) {
			initVideos();
		}
		$('.com-banner__play-video-btn').click(playVideo);
		$('.com-banner video').on('play', function() {
			$(this).closest('.com-banner').find('.com-banner__play-video-btn').trigger('click');
		});
	};

	function initVideos() {
        $('.videos-init-js').each(function() {
            var videoId = $(this).attr('data-id');
            var source = $(`.com-banner-video-mp4-${videoId}`);
            var data = $(`#com-banner-video-${videoId}`).attr('data-src');
            var video = $(`video[id=com-banner-video-${videoId}]`);

            source.attr('src', data);

            if (video.hasClass('autoplay')) {
                video[0].muted = true;
                video[0].loop = true;
                video[0].autoplay = true;
            }
            if (video.hasClass('noloop')) {
                video[0].loop = false;
            }
            video[0].load();
        });
	}

	function playVideo() {
		var btn = $(this);
		var imageCtn = btn.closest('.com-banner__image');
		var component = btn.closest('.com-banner__inner');
		var video = component.find('.com-banner__video video');

		video.get(0).play();
		imageCtn.fadeOut(function() {
			component.css('height', video.outerHeight());
			setTimeout(function() {
				component.addClass('com-banner__inner_playing');
				component.removeAttr('style');
			}, 400);
		});
	}

	$(window).ready(function() {
		init();
	});
})(jQuery);
